import { SVGProps } from 'react';

const TemplateIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.0084 2.00968C1.7896 2.22847 1.66669 2.52522 1.66669 2.83464V5.16797C1.66669 5.47739 1.7896 5.77413 2.0084 5.99293C2.22719 6.21172 2.52393 6.33464 2.83335 6.33464H19.1667C19.4761 6.33464 19.7729 6.21172 19.9916 5.99293C20.2104 5.77413 20.3334 5.47739 20.3334 5.16797V2.83464C20.3334 2.52522 20.2104 2.22847 19.9916 2.00968C19.7729 1.79089 19.4761 1.66797 19.1667 1.66797H2.83335C2.52393 1.66797 2.22719 1.79089 2.0084 2.00968Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M2.0084 11.343C1.7896 11.5618 1.66669 11.8586 1.66669 12.168V19.168C1.66669 19.4774 1.7896 19.7741 2.0084 19.9929C2.22719 20.2117 2.52393 20.3346 2.83335 20.3346H9.83335C10.1428 20.3346 10.4395 20.2117 10.6583 19.9929C10.8771 19.7741 11 19.4774 11 19.168V12.168C11 11.8586 10.8771 11.5618 10.6583 11.343C10.4395 11.1242 10.1428 11.0013 9.83335 11.0013H2.83335C2.52393 11.0013 2.22719 11.1242 2.0084 11.343Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M16.0084 11.343C15.7896 11.5618 15.6667 11.8586 15.6667 12.168V19.168C15.6667 19.4774 15.7896 19.7741 16.0084 19.9929C16.2272 20.2117 16.5239 20.3346 16.8334 20.3346H19.1667C19.4761 20.3346 19.7729 20.2117 19.9916 19.9929C20.2104 19.7741 20.3334 19.4774 20.3334 19.168V12.168C20.3334 11.8586 20.2104 11.5618 19.9916 11.343C19.7729 11.1242 19.4761 11.0013 19.1667 11.0013H16.8334C16.5239 11.0013 16.2272 11.1242 16.0084 11.343Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export default TemplateIcon;
